import { render, staticRenderFns } from "./CarDetail.vue?vue&type=template&id=6a09749a&scoped=true&"
import script from "./CarDetail.vue?vue&type=script&lang=ts&"
export * from "./CarDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CarDetail.vue?vue&type=style&index=0&id=6a09749a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09749a",
  null
  
)

export default component.exports